const WS_TIMEOUT = 300000;

const ONBOARDING_INIT_LOCAL_STORAGE = 'onboardingInit';

export { ONBOARDING_INIT_LOCAL_STORAGE, WS_TIMEOUT };
